import { render, staticRenderFns } from "./RateIcon.vue?vue&type=template&id=44a1a5f9&"
import script from "./RateIcon.vue?vue&type=script&lang=js&"
export * from "./RateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports